import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Star } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 px-4 overflow-hidden bg-[url('https://images.unsplash.com/photo-1617137984095-74e4e5e3613f?q=80&w=2121&auto=format&fit=crop')] bg-cover bg-center bg-no-repeat bg-blend-overlay bg-black/80" data-id="element-68">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/80 to-brand-black" data-id="element-69"></div>

      <div className="container mx-auto max-w-6xl relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-70">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-left" data-id="element-71">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full mb-6 border border-white/10" data-id="element-72">
            <div className="flex space-x-1" data-id="element-73">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 text-brand-gold fill-brand-gold" data-id="element-74" />)}
            </div>
            <span className="text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-75">
              Método Verificado
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-heading font-bold text-white leading-[0.9] mb-6" data-id="element-76">
            No sos <span className="text-brand-red" data-id="element-77">invisible</span>.
            <br data-id="element-78" />
            Estás jugando con el código equivocado.
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-lg leading-relaxed" data-id="element-79">
            Si siempre terminás siendo "el amigo" o te dejan en visto sin
            explicación... no es tu personalidad. Es el marco desde el que estás
            operando.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-80">
            <Button className="w-full sm:w-auto text-xl px-10 py-5" data-id="element-81">
              Descargar Ahora por{' '}
              <PriceDisplay amount={23.9} className="ml-2" data-id="element-82" />
            </Button>
          </div>

          <div className="flex items-center space-x-4 text-sm text-gray-400" data-id="element-83">
            <div className="flex items-center" data-id="element-84">
              <ShieldCheck className="w-4 h-4 mr-1 text-brand-gold" data-id="element-85" />
              <span data-id="element-86">Pago 100% Seguro</span>
            </div>
            <div className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-87"></div>
            <div data-id="element-88">Acceso Inmediato</div>
          </div>
        </motion.div>

        {/* Right Column: Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative hidden lg:block" data-id="element-89">
          <div className="relative z-10 bg-gradient-to-tr from-brand-gray to-brand-dark border border-white/10 rounded-lg p-2 shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-90">
            {/* Placeholder for Product Image */}
            <div className="aspect-[3/4] bg-black rounded overflow-hidden relative" data-id="element-91">
              <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop" alt="Código Deseo Manual" className="object-cover w-full h-full opacity-60 hover:opacity-80 transition-opacity" data-id="element-92" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-93">
                <h3 className="font-heading text-4xl text-white font-bold border-4 border-white p-4 uppercase tracking-widest" data-id="element-94">
                  Código Deseo
                </h3>
              </div>
            </div>
          </div>

          {/* Decorative elements */}
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-brand-red/20 rounded-full blur-3xl" data-id="element-95"></div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-96"></div>
        </motion.div>
      </div>
    </section>;
}